export const FACILITIES = [
  { value: '24hr', label: '24 Hours' },
  { value: 'balcony', label: 'Balcony' },
  { value: 'bike', label: 'Bike Parking' },
  { value: 'bills-included', label: 'Bills Included' },
  { value: 'cafe', label: 'On Site Cafe' },
  { value: 'central', label: 'Central' },
  { value: 'cinema', label: 'Cinema' },
  { value: 'co-working', label: 'Coworking' },
  { value: 'concierge', label: 'Concierge' },
  { value: 'garden', label: 'Garden' },
  { value: 'communalgarden', label: 'Communal Gardens' },
  { value: 'electric-car', label: 'Electric Car Hire' },
  { value: 'gated', label: 'Gated Community' },
  { value: 'golf', label: 'Indoor Golf' },
  { value: 'gym', label: 'Gym' },
  { value: 'laundry-facilities', label: 'Laundry Facilities' },
  { value: 'library', label: 'Library' },
  { value: 'lounge', label: 'Lounge' },
  { value: 'maintenance', label: 'Onsite Maintenance' },
  { value: 'nursery', label: 'Nursery' },
  { value: 'parcel-lockers', label: 'Parcel Lockers' },
  { value: 'parking', label: 'Parking' },
  { value: 'pet', label: 'Pet Friendly' },
  { value: 'playroom', label: 'Play Area' },
  { value: 'private-dining', label: 'Private Dining' },
  { value: 'resident-events', label: 'Resident Events' },
  { value: 'retail', label: 'Retail on Site' },
  { value: 'roof', label: 'Retail on Site' },
  { value: 'securestorage', label: 'Secure Storage' },
  { value: 'security', label: 'Security' },
  { value: 'service', label: 'Service' },
  { value: 'spa', label: 'Spa' },
  { value: 'storage', label: 'Storage' },
  { value: 'swim', label: 'Swimming Pool' },
  { value: 'wifi-included', label: 'WiFi Included' },
]

export const RATING_OPTIONS = [
  {
    label: 'All Ratings',
    value: '',
  },
  {
    label: '5 Stars',
    value: 5,
  },
  {
    label: '4 Stars',
    value: 4,
  },
  {
    label: '3 Stars',
    value: 3,
  },
  {
    label: '2 Stars',
    value: 2,
  },
  {
    label: '1 Star',
    value: 1,
  },
]
